<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-header-title">Change Password</h3>
    </div>

    <div class="card-body form-gorup-last">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">New Password</label>
            <input
              type="password"
              name="password"
              class="form-control"
              autocomplete="off"
              v-model="password"
              v-validate="'required|password'" />

            <help-block field="password"/>
          </div><!-- /.form-group -->

        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">Confirm New Password</label>
            <input
              type="password"
              class="form-control"
              autocomplete="off"
              name="password_confirmation"
              ref="password_confirmation"
              data-vv-as="password"
              v-validate="{ required: true, password: true, is: password }"
              v-model="passwordConfirmation"/>

            <help-block v-if="!passwordsDontMatch" field="password_confirmation"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-12 text-right">
          <div class="form-group">
            <ladda-button :click="handleSavePassword" :validate="true" class="btn btn-success">Change Password</ladda-button>
          </div><!-- /.form-group -->
        </div>
      </div><!-- /.row -->

      <div v-if="passwordsDontMatch" class="alert alert-danger">
        <strong>Error.</strong> Passwords do not match.
      </div><!-- /.alert -->
    </div>
  </div><!-- /.card -->
</template>

<script>
import { userComputed, userMethods } from 'vx/helpers'
import { handleServerErrors } from 'utils'

export default {
  data () {
    return {
      password: null,
      passwordConfirmation: null
    }
  },

  computed: {
    ...userComputed,

    passwordsDontMatch () {
      return this.errors.collect('password_confirmation', 'password').includes('The password confirmation does not match.')
    }
  },

  methods: {
    ...userMethods,

    /**
     * Update the user's password
     */
    async handleSavePassword () {
      try {
        await this.updatePassword({ password: this.password, password_confirmation: this.passwordConfirmation })

        // clear fields
        this.passwordConfirmation = null
        this.password = null

        document.activeElement.blur()

        this.$validator.reset()

        this.$noty.success('Password has been changed.')
      } catch (error) {
        handleServerErrors(error, this.$validator)
      }
    }
  }
}
</script>
